// @flow strict

import * as React from 'react'

import { PersonDetails } from '@mondough/public-web-components'
import styles from './EventsSpeakersList.module.scss'

type SpeakerProps = {
  name: string,
  img: string,
  bio: string,
  video?: string,
}

type EventsSpeakersListsProps = {
  speakers: SpeakerProps[],
}

const apostropheRuleForPossesiveNames = name => {
  const firstName = name.split(' ')[0]
  const firstNameEndsWithS = /s$/.test(firstName)

  return firstNameEndsWithS ? `${firstName}'` : `${firstName}'s`
}

const Speaker = ({ name, img, bio, video }: SpeakerProps) => (
  <PersonDetails image={<img src={img} alt={name} />}>
    <PersonDetails.Heading>{name}</PersonDetails.Heading>
    <PersonDetails.Text>{bio}</PersonDetails.Text>
    {video ? (
      <PersonDetails.Link href={video}>
        {`View ${apostropheRuleForPossesiveNames(name)} talk`}
      </PersonDetails.Link>
    ) : (
      undefined
    )}
  </PersonDetails>
)

const EventsSpeakersLists = ({ speakers }: EventsSpeakersListsProps) => (
  <ul className={styles.list}>
    {speakers &&
      speakers.map(speaker => (
        <li className={styles.item} key={speaker.name}>
          <Speaker {...speaker} />
        </li>
      ))}
  </ul>
)

export default EventsSpeakersLists
